import React, { useState } from 'react';
import './style.css';
import { LabeledInput } from '../../Components/index';
const Profile = () => {
    const [firstName, setFirstName] = useState('Nishant');
    const [lastName, setLastName] = useState('Tanwar');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('+918827731259');

    return (
        <>
            <div className="setting_profile">
                <div className="home_head">
                    <h2 className="home_heading">Personal Details</h2>
                </div>
                <div className="settings_body">
                    <LabeledInput
                        name="first name"
                        value={firstName}
                        changeHandler={(e) => {
                            setFirstName(e.target.value);
                        }}
                        label={'First Name'}
                    />
                    <LabeledInput
                        name="last name"
                        value={lastName}
                        changeHandler={(e) => {
                            setLastName(e.target.value);
                        }}
                        label={'Last Name'}
                    />
                    <div>
                        <LabeledInput
                            style={{ width: '100%' }}
                            name="email"
                            value={email}
                            changeHandler={(e) => {
                                setEmail(e.target.value);
                            }}
                            label={'Email'}
                        />
                        <p className="input_info">Please contact our support to change this email address</p>
                    </div>
                    <LabeledInput
                        name="phone"
                        value={phone}
                        changeHandler={(e) => {
                            setPhone(e.target.value);
                        }}
                        label={'Phone Number'}
                    />
                    <div className="footer_setting">
                        <button className="btn-orange">Save Changes</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Profile;
